export default __webpack_public_path__ + "static/media/prev-hybridshellkeychain.804a10b8.jpg";